import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { ENV } from '../utils/env';

const firebaseConfig = {
    apiKey: ENV.FIREBASE_API_KEY(),
    authDomain: ENV.FIREBASE_AUTH_DOMAIN(),
    projectId: ENV.FIREBASE_PROJECT_ID(),
    storageBucket: ENV.FIREBASE_STORAGE_BUCKET(),
    messagingSenderId: ENV.FIREBASE_MESSAGING_SENDER_ID(),
    appId: ENV.FIREBASE_APP_ID(),
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

export default app;
